import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetEventsFromTopLeaguesBySportId = QueryFactory(SD.QueryTypes.GetEventsFromTopLeaguesBySportId);
//# sourceMappingURL=QGetEventsFromTopLeaguesBySportId.js.map